import type { QuickAction } from "@/types";

export const mockQuickActions: QuickAction[] = [
  {
    id: "qa-1",
    title: "Start guided assessment",
    description: "Walk through FinOps dimensions with structured prompts.",
  },
  {
    id: "qa-2",
    title: "Upload cost export",
    description: "Prepare a CSV or connect a data source (coming soon).",
  },
  {
    id: "qa-3",
    title: "Review last session",
    description: "Open your most recent assessment to continue the thread.",
    href: "/assessments/sess_demo_001",
  },
];
